"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteTextFilter = void 0;
const tslib_1 = require("tslib");
const SiteText_1 = require("../lib/SiteText");
const store_1 = tslib_1.__importDefault(require("../store"));
function getSiteTextFilter(optionsFn) {
    return (key, replacements, debug) => {
        const options = optionsFn();
        replacements = replacements || options.replacements;
        if (debug === undefined) {
            debug = options.debug || false;
        }
        const siteTextMap = options.siteTextMap || {};
        return (0, SiteText_1.getSiteTextItem)(key, { debug, replacements, siteTextMap });
    };
}
exports.siteTextFilter = getSiteTextFilter(() => {
    return {
        siteTextMap: store_1.default.getters.siteTextMap,
        debug: store_1.default.getters.debugSiteText,
    };
});
